import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.itemValues || initialState;

export const selectSelectedItem = createSelector([selectSlice], state => state);

export const selectSavedItem = createSelector(
  [selectSlice, (state, currentStep) => currentStep],
  (itemValues, currentStep) => {
    if (!Array.isArray(itemValues[currentStep]?.item)) {
      return itemValues[currentStep]?.item;
    }
    return null;
  },
);

export const selectActuatorFilter = createSelector(
  [selectSlice],
  state => state[2]?.filters || null,
);
